/**
 * Utilities for phone formatting and validation
 */

/**
 * Formats a phone number applying the mask (XX) XXXXX-XXXX
 * @param value - Phone value without formatting
 * @returns Formatted phone
 */
export const formatPhone = (value: string): string => {
  // Remove everything that is not a digit
  const numbers = value.replace(/\D/g, '');

  // Apply phone mask (XX) XXXXX-XXXX
  return numbers
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .slice(0, 15); // Limit to 15 characters (2 + 2 + 1 + 5 + 1 + 4)
};

/**
 * Validates if a phone number is valid (mobile with area code)
 * @param phone - Phone with or without formatting
 * @returns true if the phone is valid
 */
export const validatePhone = (phone: string): boolean => {
  const cleanPhone = phone.replace(/\D/g, '');

  // Check if it has 11 digits (area code + 9 digits)
  if (cleanPhone.length !== 11) return false;

  // Check if the first digit after area code is 9 (mobile)
  if (cleanPhone.charAt(2) !== '9') return false;

  return true;
};

/**
 * Removes phone formatting, returning only numbers
 * @param phone - Formatted phone
 * @returns Phone with only numbers
 */
export const cleanPhone = (phone: string): string => {
  return phone.replace(/\D/g, '');
};

/**
 * Verifica se o número é de celular (Brasil: 9 após DDD).
 * SMS só deve ser enviado para celular.
 * @param phone - Telefone com ou sem formatação (pode incluir 55)
 * @returns true se for número de celular
 */
export const isCelular = (phone: string): boolean => {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 11) {
    // DDD (2) + 9 + 8 dígitos → celular tem 9 na posição 2
    return digits.charAt(2) === '9';
  }
  if (digits.length === 13 && digits.startsWith('55')) {
    // 55 + DDD (2) + 9 + 8 dígitos
    return digits.charAt(4) === '9';
  }
  return false;
};
